import React from 'react';
import firebase from 'firebase/app';
import 'firebase/firestore';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { Container } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import {authConfig} from '../auth/config';

var listaunidadest=[];
var codunidadetransporte='';
export default function  ParadaMap () {
  
    const [dataini, setadataini] = React.useState('');

  const [datafim, setadatafim] = React.useState('');
    const [statelista, setalista]=React.useState(['']);
const [statetipoveiculo,setatipoveiculo]=React.useState([{
    id:'', label:''
}]);
const[codtipo,setacodtipo]=React.useState('');
    React.useEffect (()=>{
        
        firebase.firestore().collection("tiposveiculo")
        .get()
        .then(function(querySnapshot) {
            listaunidadest=[];
            querySnapshot.forEach(function(doc) {
                listaunidadest.push({id: doc.id, label: doc.data().tipoveiculo,
                listacatmotoras: doc.data().categoriasmotorista, valorkmrodado:doc.data().valorkmrodado,
                });
            })
            setalista(listaunidadest)
            console.log("listass tipos de veiculos: ", listaunidadest);
        })
        .catch(function(error) {
            console.log("erro carregar as unidades de tipos veiculos: ", error);
            alert('Não foi Possível carregar os tipos de veículos.');
        });
         
        pegauser()
        
            },[0])

            async function pegauser() {
              var cod1='';
              var cod2='';
              const user = authConfig.auth().currentUser;
                 var db = firebase.firestore();
                 var userref =  db.collection("usuarios").doc(user.uid);         
                 await  userref.get().then((doc) => {       
                  if (doc.exists) {
                                   
                   cod1=doc.data().vinculocodunidadetransporte;
                   cod2=doc.data().codunidadetransporte;
                   if ((cod1!='')&&(cod1!=undefined)) {
                     codunidadetransporte=cod1;
                     
                   } else {
                    if ((cod2!='')&&(cod2!=undefined)) {
                      codunidadetransporte=cod2;
                      
                    }
                     
                   }
 
                 }else{
                   alert('Não encontramos o seu cadastro')
                 }
                
                }).catch(function(error) {
                  alert("Erro ao localizar o seu cadastro ", error.message);
                  })
                  
            }

    function consultadispo() {
      if( ((dataini!=undefined)&& (dataini!=''))&&((datafim!=undefined)&& (datafim!=''))
      &&((statetipoveiculo[0].id!=undefined)&& (statetipoveiculo[0].id!=''))) {
        var listdef=[];
        var ctl=0;
        firebase.firestore().collection("veiculos").where('codtipoveiculo','==',statetipoveiculo[0].id)
        .where('codunidadetransporte','==',codunidadetransporte).where('status','==',true)
        .get()
        .then(function(querySnapshot) {
            listaunidadest=[];
            querySnapshot.forEach(function(doc) {
                listaunidadest.push({id: doc.id, label: doc.data().modelo + ' - '+ doc.data().placa, livre:true,

            });
            })

            console.log("listass tipos de veiculos: ", listaunidadest);
            
            
                       for (let ndex = 0; ndex < listaunidadest.length; ndex++) {
                                var db1 = firebase.firestore();
                    var userref = db1.collection("veiculos").doc(listaunidadest[ndex].id).collection("reservas");
                    userref.get().then(function(querySnapshot) {
                       
                        
                        querySnapshot.forEach(function(doc) {
                            console.log(doc.data().datainicio);
                            if((doc.data().datainicio!=undefined)&&(doc.data().datafim!=undefined)){
                                
                                if(((firebase.firestore.Timestamp.fromDate(new Date(dataini))>=doc.data().datainicio)&&(firebase.firestore.Timestamp.fromDate(new Date(dataini))<doc.data().datafim))||
                                ((firebase.firestore.Timestamp.fromDate(new Date(dataini))<=doc.data().datainicio)&&(firebase.firestore.Timestamp.fromDate(new Date(datafim))>doc.data().datainicio))){
                                    listaunidadest[ndex].livre=false;
                                }

                        }
                            
                        })
                        listdef=[];
                        for (let x = 0; x < listaunidadest.length; x++) {
            
                            if(listaunidadest[x].livre==true){
                                listdef.push(listaunidadest[x]);
                            }
                            
                        }
                        
                        if(ctl==0){
                          ctl=1;
                        if(listdef.length>0){
                          alert("No momento há disponibilidade de veículo na data desejada, porém isto não é garantia de deferimento da sua solicitação.")
                        }else{
                          alert("Não encontramos um veículo disponivel na data desejada.")
                        }
                      }
                        
                                      
                   
            }).catch(function(error) {
                console.log("erro carregar as unidades de tipos veiculos: ", error);
                alert('Não foi Possível carregar Motoristas.');
            });
        }

        
//setalista(listaunidadest);
        })
        .catch(function(error) {
            console.log("erro carregar as unidades de tipos veiculos: ", error);
            alert('Não foi Possível carregar os veículos.');
        });
    
        
        
      } else {
        alert("Para realizar a consulta preencha todos os campos.")
        
      }
      
    }       
   

    const handleuniade=(event,value)=>{
       
        setatipoveiculo([value]);
        console.log("targekkkkkkkkkkkkkkkkkkt ", value);
        if((value!=undefined)||(value!=null)){
        //props.setatipoveiculo([value]);
        console.log("targekkkkkkkkkkkkkkkkkkt ", value);
        //setatipoveiculo(value),
        }
       
    }
    
    return(
<Container maxWidth="xs">
        <div>
          <text > Aqui você pode consultar a disponibilidade para a data pretendida!
            
            </text>
  <br></br>
  <br></br>
            <TextField
      fullWidth
      required
      onChange={ e=>setadataini(e.target.value)}
      variant="outlined"
        id="datetimeini"
        label="Data e Hora Inicial do deslocamento"
        type="datetime-local"
        value={dataini}
        //className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}      
      />
      <br></br>
      <br></br>

<TextField
      fullWidth
      required
     onChange={ e=>setadatafim(e.target.value)}
      variant="outlined"
        id="datetimefim"
        label="Data e hora prevista para chegada do Retorno"
        type="datetime-local"
        value={datafim}
       // className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}      
      />
<br></br>
<br></br>
<Autocomplete onChange={handleuniade}
                    

                    id="combounidadetchef"
                    options={statelista}
                    //disabled={props.disabled}
                    getOptionLabel={(option) =>(typeof option === 'string' ? option :option.label)}
                   // value={tipoveiculo1[0]}
                   value={statetipoveiculo[0]}
                   //defaultValue={tipoveiculo1[0]}
                   getOptionSelected={(option,temp) => option.id==temp.id}
                    renderInput={(params) => <TextField {...params}  label="Tipo de Veículo" variant="outlined" />}
                />
                
<br></br>
                <Button
           // type="submit"
            fullWidth
            variant="contained"
            color="primary"
            //className={classes.menuButton}
            onClick = {consultadispo}        
              >
            Consultar
          </Button>


          </div>
          </Container>
        
                
)
}